module.exports = __webpack_public_path__ + "static/media/IMG_0051.2736467c.JPG";